/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RoofOverhangStyle {
    None = 0,
    FrontOnly = 1,
}
